import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { BULLETIN_FEED_FILTERS, BulletinFeedFilter } from '@/types/admin/bulletins';
import { TabSegment, type TabSegmentItem } from '@/components/shared/redesign';

interface BulletinFeedTabsProps {
  activeFilter: BulletinFeedFilter;
  onFilterChange: (filter: BulletinFeedFilter) => void;
}

export const BulletinFeedTabs: React.FC<BulletinFeedTabsProps> = ({
  activeFilter,
  onFilterChange,
}) => {
  const items = useMemo<TabSegmentItem<BulletinFeedFilter>[]>(
    () => [
      { key: BULLETIN_FEED_FILTERS.FEED, label: 'Feed' },
      { key: BULLETIN_FEED_FILTERS.SCHEDULED, label: 'Scheduled' },
      { key: BULLETIN_FEED_FILTERS.DRAFT, label: 'Draft' },
    ],
    [],
  );

  return (
    <View style={styles.wrapper}>
      <TabSegment<BulletinFeedFilter>
        items={items}
        selectedKey={activeFilter}
        onChange={onFilterChange}
        variant="pill"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    marginBottom: 16,
  },
});
